import React from 'react';
import Header from "../components/Header/Header";
import PartnersSection from "../Home/components/PartnersSection/PartnersSection";
import Footer from "../components/Footer/Footer";
import exec2 from './Ресурс 19@3x.png';
import exec3 from './developmentProgram.jpg';
import exec4 from './uib1.png';
import grad_model from './model_graduate.png'
import teacher1 from './abitova.jpg';
import teacher2 from './edilxan.png';
import teacher3 from './adamova.jpg';
import teacher4 from './rzayeva.png';
import teacher5 from './asemgul.jpg';
import teacher6 from './toxanov.png';
import styles from './new_mba.module.css';
import {CalendarOutlined, FileTextOutlined, FormOutlined, GlobalOutlined, TrophyOutlined,} from "@ant-design/icons";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import {Fade} from "react-awesome-reveal";

const MBAFintechPage = () => {
    const outcomes = [
        {titleKey: "mba-fin-outcome-1-title", descKey: "mba-fin-outcome-1-desc"},
        {titleKey: "mba-fin-outcome-2-title", descKey: "mba-fin-outcome-2-desc"},
        {titleKey: "mba-fin-outcome-3-title", descKey: "mba-fin-outcome-3-desc"},
        {titleKey: "mba-fin-outcome-4-title", descKey: "mba-fin-outcome-4-desc"},
        {titleKey: "mba-fin-outcome-5-title", descKey: "mba-fin-outcome-5-desc"},
        {titleKey: "mba-fin-outcome-6-title", descKey: "mba-fin-outcome-6-desc"},
        {titleKey: "mba-fin-outcome-7-title", descKey: "mba-fin-outcome-7-desc"},
        {titleKey: "mba-fin-outcome-8-title", descKey: "mba-fin-outcome-8-desc"},
        {titleKey: "mba-fin-outcome-9-title", descKey: "mba-fin-outcome-9-desc"},
    ];

    const teachers = [
        {name: "mba-fin-tr-1n", desc: "mba-fin-tr-1d", img: teacher1},
        {name: "mba-fin-tr-2n", desc: "mba-fin-tr-2d", img: teacher2},
        {name: "mba-fin-tr-3n", desc: "mba-fin-tr-3d", img: teacher3},
        {name: "mba-fin-tr-4n", desc: "mba-fin-tr-4d", img: teacher4},
        {name: "mba-fin-tr-5n", desc: "mba-fin-tr-5d", img: teacher5},
    ];

    const mandatoryDisciplines = [
        "mba-fin-md-1", "mba-fin-md-2", "mba-fin-md-3", "mba-fin-md-4",
        "mba-fin-md-5", "mba-fin-md-6", "mba-fin-md-7", "mba-fin-md-8",
        "mba-fin-md-9", "mba-fin-md-10", "mba-fin-md-11", "mba-fin-md-12",
        "mba-fin-md-13",
    ];

    const electiveA = [
        "mba-fin-ch-3-1", "mba-fin-ch-3-2", "mba-fin-ch-3-3",
        "mba-fin-ch-3-4", "mba-fin-ch-3-5",
    ];

    const electiveB = [
        "mba-fin-ch-4-1", "mba-fin-ch-4-2", "mba-fin-ch-4-3",
        "mba-fin-ch-4-4", "mba-fin-ch-4-5",
    ];

    return (
        <div className={styles.page}>
            <Header/>

            {/* Hero */}
            <section className={styles.hero}>
                <div className={styles.heroInner}>
                    <Fade triggerOnce cascade damping={0.15} direction="down">
                        <div className={styles.heroText}>
                            <h1 className={styles.heroTitle}>
                                <IntlMessage id="mba-fintech"/>
                            </h1>
                            <p className={styles.heroSubtitle}>
                                <IntlMessage id="mba-fin-h1"/>
                            </p>
                            <p className={styles.heroPartner}>
                                <IntlMessage id="mba-fin-h2"/>
                            </p>
                            <p className={styles.heroCode}>
                                <IntlMessage id="mba-fin-code"/>
                            </p>
                        </div>
                    </Fade>
                    {/*<Fade triggerOnce direction="left">*/}
                    {/*    <div className={styles.heroLogos}>*/}
                    {/*        <img src={img2} alt="" width={100}/>*/}
                    {/*        <img src={img3} alt="" width={100}/>*/}
                    {/*    </div>*/}
                    {/*</Fade>*/}
                </div>
            </section>

            {/* Facts strip */}
            <div className={styles.factsStrip}>
                <div className={styles.factsInner}>
                    <Fade triggerOnce cascade damping={0.1} direction="up">
                        <div className={styles.factItem}>
                            <p className={styles.factLabel}>
                                <CalendarOutlined/> <IntlMessage id="trainDuration"/>
                            </p>
                            <p className={styles.factValue}>24 <IntlMessage id="months"/></p>
                        </div>
                        <div className={styles.factItem}>
                            <p className={styles.factLabel}>
                                <FileTextOutlined/> <IntlMessage id="mba-fin-credits"/>
                            </p>
                            <p className={styles.factValue}><IntlMessage id="mba-fin-credits-val"/></p>
                        </div>
                        <div className={styles.factItem}>
                            <p className={styles.factLabel}>
                                <FormOutlined/> <IntlMessage id="trainFormat"/>
                            </p>
                            <p className={styles.factValue}><IntlMessage id="mba-fin-format-val"/></p>
                        </div>
                        <div className={styles.factItem}>
                            <p className={styles.factLabel}>
                                <GlobalOutlined/> <IntlMessage id="trainLanguage"/>
                            </p>
                            <p className={styles.factValue}><IntlMessage id="mba-fin-lang-val"/></p>
                        </div>
                        <div className={styles.factItem}>
                            <p className={styles.factLabel}>
                                <TrophyOutlined/> <IntlMessage id="mba-fin-degree"/>
                            </p>
                            <p className={styles.factValue}><IntlMessage id="mba-fin-degree-val"/></p>
                        </div>
                    </Fade>
                </div>
            </div>

            {/* Program Goal */}
            <div className={styles.section}>
                <Fade triggerOnce direction="down">
                    <h2 className={styles.sectionTitle}>
                        <IntlMessage id="mba-fin-goal-title"/>
                    </h2>
                </Fade>
                <Fade triggerOnce direction="left">
                    <p className={styles.descText}>
                        <IntlMessage id="mba-fin-goal-desc"/>
                    </p>
                    <p className={styles.descText} style={{fontWeight: 600, color: '#333'}}>
                        <IntlMessage id="mba-fin-goal-directions"/>
                    </p>
                    <ul className={styles.goalsList}>
                        <li><IntlMessage id="mba-fin-goal-1"/></li>
                        <li><IntlMessage id="mba-fin-goal-2"/></li>
                        <li><IntlMessage id="mba-fin-goal-3"/></li>
                        <li><IntlMessage id="mba-fin-goal-4"/></li>
                        <li><IntlMessage id="mba-fin-goal-5"/></li>
                        <li><IntlMessage id="mba-fin-goal-6"/></li>
                    </ul>
                </Fade>

                {/* Contact card */}
                {/*<Fade triggerOnce direction="up">*/}
                {/*    <div className={styles.contactCard}>*/}
                {/*        <h4><IntlMessage id="mba-fin-contact-title"/></h4>*/}
                {/*        <p><PhoneOutlined/> <IntlMessage id="mba-fin-contact-phone"/></p>*/}
                {/*        <p><MailOutlined/> <IntlMessage id="mba-fin-contact-email"/></p>*/}
                {/*        <p><ClockCircleOutlined/> <IntlMessage id="mba-fin-contact-time"/></p>*/}
                {/*    </div>*/}
                {/*</Fade>*/}
            </div>

            {/* Program Structure */}
            <div className={styles.sectionAlt}>
                <div className={styles.sectionAltInner}>
                    <Fade triggerOnce direction="down">
                        <h2 className={styles.sectionTitle}>
                            <IntlMessage id="programStructure"/>
                        </h2>
                    </Fade>

                    <div className={styles.structureGrid}>
                        {/* Mandatory disciplines */}
                        <Fade triggerOnce direction="left">
                            <div className={styles.structureBlock}>
                                <div className={styles.structureBlockHeader}>
                                    <IntlMessage id="mandatoryDisp"/>
                                </div>
                                <div className={styles.structureBlockBody}>
                                    <ul>
                                        {mandatoryDisciplines.map((key) => (
                                            <li key={key}><IntlMessage id={key}/></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </Fade>

                        {/* Elective modules */}
                        <Fade triggerOnce direction="right">
                            <div className={styles.structureBlock}>
                                <div className={styles.structureBlockHeaderAlt}>
                                    <IntlMessage id="chooseModules"/>
                                </div>
                                <div className={styles.structureBlockBody}>
                                    <div>
                                        <p className={styles.electiveSubTitle}>
                                            <IntlMessage id="mba-fin-ch-1"/>
                                        </p>
                                        <ul>
                                            {electiveA.map((key) => (
                                                <li key={key}><IntlMessage id={key}/></li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className={styles.electiveSubBlock}>
                                        <p className={styles.electiveSubTitle}>
                                            <IntlMessage id="mba-fin-ch-2"/>
                                        </p>
                                        <ul>
                                            {electiveB.map((key) => (
                                                <li key={key}><IntlMessage id={key}/></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
            </div>

            {/* Learning Outcomes */}
            <div className={styles.section}>
                <Fade triggerOnce direction="down">
                    <h2 className={styles.sectionTitle}>
                        <IntlMessage id="mba-fin-outcomes-title"/>
                    </h2>
                </Fade>
                <div className={styles.outcomesGrid}>
                    {outcomes.map((outcome, index) => (
                        <Fade triggerOnce direction="up" delay={index * 40} key={index}>
                            <div className={styles.outcomeCard}>
                                <h4><IntlMessage id={outcome.titleKey}/></h4>
                                <p><IntlMessage id={outcome.descKey}/></p>
                            </div>
                        </Fade>
                    ))}
                </div>
            </div>

            {/* Teachers */}
            <div className={styles.sectionAlt}>
                <div className={styles.sectionAltInner}>
                    <Fade triggerOnce direction="down">
                        <h2 className={styles.sectionTitle}>
                            <IntlMessage id="ourTeachers"/>
                        </h2>
                    </Fade>
                    <div className={styles.teachersGrid}>
                        {teachers.map((teacher, index) => (
                            <Fade triggerOnce direction="up" delay={index * 60} key={index}>
                                <div className={styles.teacherCard}>
                                    <img src={teacher.img} alt=""/>
                                    <h3><IntlMessage id={teacher.name}/></h3>
                                    <p><IntlMessage id={teacher.desc}/></p>
                                </div>
                            </Fade>
                        ))}
                    </div>
                </div>
            </div>

            {/* Graduate Diplomas */}
            <div className={styles.section}>
                <Fade triggerOnce direction="down">
                    <h2 className={styles.sectionTitle}>
                        <IntlMessage id="graduateDiplomas"/>
                    </h2>
                </Fade>
                <div className={styles.diplomasGrid}>
                    <Fade triggerOnce direction="up">
                        <div className={styles.diplomaCard}>
                            <img src={exec2} alt=""/>
                            <p><IntlMessage id="mba-fin-dip-1"/></p>
                        </div>
                    </Fade>
                    <Fade triggerOnce direction="up" delay={100}>
                        <div className={styles.diplomaCard}>
                            <img src={exec4} alt=""/>
                            <p><IntlMessage id="mba-fin-dip-2"/></p>
                        </div>
                    </Fade>
                </div>
            </div>

            {/* Graduate student model */}
            <div className={styles.sectionAlt}>
                <div className={styles.sectionAltInner}>
                    <Fade triggerOnce direction="down">
                        <h2 className={styles.sectionTitle}>
                            <IntlMessage id="graduateStudentModel"/>
                        </h2>
                    </Fade>
                    <Fade triggerOnce direction="up">
                        <img style={{
                            maxWidth: "100%", borderRadius: "8px",
                        }} src={grad_model} alt=""/>
                    </Fade>
                </div>
            </div>

            {/* Required docs */}
            <div className={styles.section}>
                <div className={styles.sectionAltInner}>
                    <Fade triggerOnce direction="down">
                        <h2 className={styles.sectionTitle}>
                            <IntlMessage id="requiredDocuments"/>
                        </h2>
                    </Fade>
                    <div className={styles.docsGrid}>
                        <Fade triggerOnce direction="left">
                            <ul className={styles.goalsList}>
                                <li><IntlMessage id="mbaFinDoc1"/></li>
                                <li><IntlMessage id="mbaFinDoc2"/></li>
                                <li><IntlMessage id="mbaFinDoc3"/></li>
                                <li><IntlMessage id="mbaFinDoc4"/></li>
                                <li><IntlMessage id="mbaFinDoc5"/></li>
                                <li><IntlMessage id="mbaFinDoc6"/></li>
                                <li><IntlMessage id="mbaFinDoc7"/></li>
                                <li><IntlMessage id="mbaFinDoc8"/></li>
                                <li><IntlMessage id="mbaFinDoc9"/></li>
                            </ul>
                        </Fade>
                        <Fade triggerOnce direction="right">
                            <a href="https://drive.google.com/file/d/1AVQKQTb2Fw_AuvZtQRJDfHn7rHELnCgz/view?usp=sharing" target="_blank" rel="noopener noreferrer"
                               className={styles.docLink}>
                                <div className={styles.diplomaCard}>
                                    <img src={exec3} alt=""/>
                                    <p><IntlMessage id="mba-fin-req-docs-link"/></p>
                                </div>
                            </a>
                        </Fade>
                    </div>
                </div>
            </div>
            {/* Partners */}
            <div className={styles.sectionAlt}>
                <div className={styles.sectionAltInner}>
                    <PartnersSection/>
                </div>
            </div>

            <Footer/>
        </div>
    );
};

export default MBAFintechPage;
